module.exports = {
	"env": "default",
	"vanityDomain": "http://localhost:80",
	"mobileDomain": "http://localhost:80",
	"server": {
		"port": 80
	},
	"googleTagManager": {
		"id": "GTM-KTHH2N"
	},
	"dataLayer": {
		"id": "GTM-KTHH2N"
	},
	"optimizely": {
		"id": "1991061092"
	},
	"assetsPath": "/funeral-homes/obituaries/name",
	"baseUrl": {
		"protocol": "http",
		"hostname": "localhost",
		"beta": "",
		"pathname": "funeral-homes/obituaries/name",
		"port": "80"
	},
	"environmentalUrl": {
		"cacheUrl": "https://cache.dev-legacy.net/",
		"flowersUrl": "https://sympathy.dev-legacy.com/",
		"staticCacheUrl": "https://static.legacy.net/"
	},
	"apiGateway": {
		"protocol": "http",
		"domain": "apiswarm.dev-legacy.com",
		"port": "",
		"path": [
			"graphql"
		]
	},
	"internalApiGateway": {
		"protocol": "http",
		"domain": "apiswarm.dev-legacy.com",
		"port": "",
		"path": [
			"graphql"
		]
	},
	"gatewayFetch": {
		"post": {
			"options": {}
		}
	},
	"printedGuestBookUrl": "https://sympathy.dev-legacy.com/printed-obituary-guestbook/gallery/pm69/",
	"advertising": {
		"networkId": 423686928,
		"environment": "dev",
		"siteName": "obit-fhd",
		"appKeyValues": [
			{
				"cobrand": "Legacy"
			},
			{
				"country": "0"
			},
			{
				"corp": "0"
			},
			{
				"affstate": "0"
			}
		],
		"responsiveSizeMaps": [],
		"AdExtensions": []
	},
	"directoryAdvertising": {
		"networkId": 423686928,
		"environment": "dev",
		"siteName": "obit-fhd",
		"responsiveSizeMaps": [
			{
				"name": "mapping728x90Header",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[728,90],'fluid']",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[728,90],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[320,50],'fluid']",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping728x90Footer",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[728,90]]",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[728,90]]",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[300,250]]",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping300x250RightRail",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[300,250],'fluid']",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[300,250],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[]",
						"description": "Fallback"
					}
				]
			},
			{
				"name": "mapping320x250DisplayOverlay1",
				"sizes": [
					{
						"viewport": "[980,0]",
						"adSizes": "[[1,1],[728,90],[970,90],[320,50]]",
						"description": "Desktop"
					},
					{
						"viewport": "[737,0]",
						"adSizes": "[[1,1],[320,50],[728,90],'fluid']",
						"description": "Tablet"
					},
					{
						"viewport": "[0,0]",
						"adSizes": "[[1,1],[320,50],'fluid']",
						"description": "Fallback"
					}
				]
			}
		],
		"AdExtensions": []
	},
	"filepicker": {
		"key": "AivazPCCT90xpkMondIwGz"
	},
	"statsd": {
		"host": "statsd.hostedgraphite.com",
		"port": 8125,
		"apiKey": "61e3533c-03ed-43f5-911d-6197a41e4e8e.funeral-home-client.dev",
		"enableLogging": false
	},
	"logging": {
		"level": "silly"
	},
	"scriptInjector": {
		"scriptsPath": "scripts",
		"scriptLocations": [
			"head",
			"top",
			"bottom"
		]
	},
	"yotpo": {
		"apiKey": "wxikOpgP5wtGLV7R5iW76o4gQdDBgS6ICVeir6Jd"
	},
	"googleApi": {
		"apiKey": "AIzaSyCNy3AOO8BgFGoeDGZ9gh41CJtE9fAs5LQ"
	},
	"salesforce": {
		"webcollect": {
			"clientId": "r0u5kw2q5lhpz9sgsu3k7k9d",
			"clientSecret": "KGyZg4Uch5mwFT8qw3alqqXS"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/appConfig/env/default.json
// module id = 1170
// module chunks = 0